var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.501 19.9994C10.501 19.4022 10.729 18.8049 11.184 18.3494L25.517 4.01681C26.4287 3.10507 27.9069 3.10507 28.8183 4.01681C29.7297 4.92818 29.7297 6.40611 28.8183 7.31793L16.1359 19.9994L28.8174 32.6813C29.7288 33.5927 29.7288 35.0708 28.8174 35.9821C27.9061 36.8943 26.4283 36.8943 25.5165 35.9821L11.1835 21.6498C10.7286 21.1941 10.501 20.5968 10.501 19.9994Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft40Px);
export default ForwardRef;